const COLORS = {
    bg_white: "#FFFFFF",
    bg_grey: "#F4F5F0"
}

export default COLORS;